export default __webpack_public_path__ + "static/media/about-benefits-listing-preview.859799ce.jpg";